import flashes from './flashes';
import banners, { watchers as bannerWatchers } from './banners';

export const watchers = [...bannerWatchers];

export default {
  namespaced: true,
  modules: { flashes, banners },
};
